import React, { useState } from "react";
// import Counties from "./Counties";
import ConsumerPriceIndex from "./CpiChart";
import Box from "@mui/material/Box";
import { Grid, MenuItem, TextField, Divider, Typography } from "@mui/material";
import HomeSnapshot from "./HomeSnapshot";
import LastMonthCPI from "./LastMonthCPI";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MultipleYearsCpi from "./MultipleYearsCpi";
import MultiYearInflation from "./MultiYearInflation";
import SingleYearInflation from "./SingleYearInflation";
import LastMonthInflation from "./LastMonthInflation";
import ForexRates from "../Banking/ForexRates";
import InterestRates from "../Banking/InterestRates";

const status = [
  {
    value: 2022,
    label: "Year 2022",
  },
  {
    value: 2021,
    label: "Year 2021",
  },
  {
    value: 2020,
    label: "Year 2020",
  },
  {
    value: 2019,
    label: "Year 2019",
  },
  {
    value: 2018,
    label: "Year 2018",
  },
  {
    value: 2017,
    label: "Year 2017",
  },
  {
    value: 2016,
    label: "Year 2016",
  },
  {
    value: 2015,
    label: "Year 2015",
  },
  {
    value: 2014,
    label: "Year 2014",
  },
  {
    value: 2013,
    label: "Year 2013",
  },
  {
    value: 2012,
    label: "Year 2012",
  },
  {
    value: 2011,
    label: "Year 2011",
  },
];

export default function Home() {
  const [value, setValue] = useState(status[0]["value"]);

  const [alignment, setAlignment] = React.useState(1);
  const [inflationAlignment, setInflationAlignment] = React.useState(1);
  const [inflationYearValue, setInflationYearValue] = React.useState(
    status[0]["value"]
  );

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleInflationAlignmentChange = (event, newAlignment) => {
    setInflationAlignment(newAlignment);
  };

  return (
    <Box
      sx={{
        marginRight: "10px",
      }}
    >
      {/* Snapshot Begins */}
      <>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <HomeSnapshot
              data={"USD 110.35 bln"}
              description="Total GDP(2021)"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <HomeSnapshot data="6.8%" description={"GDP Growth Rate Q1 2022"} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <HomeSnapshot data="5.5%" description={"Est. GDP Growth 2022"} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <HomeSnapshot data="8.75%" description={"Central Bank Rate"} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LastMonthCPI />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LastMonthInflation />
          </Grid>
        </Grid>
      </>
      {/* Snapshot Ends */}

      {/* Inflation Section Begins */}
      <>
        <Box
          sx={{
            margin: "10px",
          }}
        />
        <Divider>
          <Typography gutterBottom variant="h5" align="center">
            Monthly Inflation Data
          </Typography>
        </Divider>

        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ marginBottom: "10px" }}
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 12, md: 6 }}
        >
          <Grid item xs={12} md={6}>
            <ToggleButtonGroup
              color="primary"
              value={inflationAlignment}
              exclusive
              onChange={handleInflationAlignmentChange}
              aria-label="Inflation Data period"
            >
              <ToggleButton value={1}>Yearly</ToggleButton>
              <ToggleButton value={5}>5 Yrs</ToggleButton>
              <ToggleButton value={10}>10 Yrs</ToggleButton>
              <ToggleButton value="all">All</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          {inflationAlignment === 1 ? (
            <Grid item xs={12} md={6}>
              <TextField
                id="standard-select-year"
                select
                value={inflationYearValue}
                onChange={(e) => setInflationYearValue(e.target.value)}
              >
                {status.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ) : (
            <Grid item></Grid>
          )}
        </Grid>

        {inflationAlignment === 1 ? (
          <Grid container>
            <Grid item xs={12}>
              {/* <Card> */}
              <SingleYearInflation year={inflationYearValue} />
              {/* </Card> */}
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              {inflationAlignment === 1 ? (
                <></>
              ) : (
                <MultiYearInflation yearValue={inflationAlignment} />
              )}
            </Grid>
          </Grid>
        )}
      </>
      {/* Inflation Section Ends */}

      {/* CPI Section Begins */}
      <>
        <Box
          sx={{
            margin: "10px",
          }}
        />
        <Divider>
          <Typography gutterBottom variant="h5" align="center">
            Monthly CPI Data
          </Typography>
        </Divider>

        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ marginBottom: "10px" }}
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 12, md: 6 }}
        >
          <Grid item>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Data period"
            >
              <ToggleButton value={1}>Yearly</ToggleButton>
              <ToggleButton value={5}>5 Yrs</ToggleButton>
              <ToggleButton value={10}>10 Yrs</ToggleButton>
              <ToggleButton value="all">All</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          {alignment === 1 ? (
            <Grid item>
              <TextField
                id="standard-select-year"
                select
                value={value}
                onChange={(e) => setValue(e.target.value)}
              >
                {status.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ) : (
            <Grid item></Grid>
          )}
        </Grid>

        {alignment === 1 ? (
          <Grid container>
            <Grid item xs={12}>
              {/* <Card> */}
              <ConsumerPriceIndex year={value} />
              {/* </Card> */}
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              {alignment === 1 ? (
                <></>
              ) : (
                <MultipleYearsCpi yearValue={alignment} />
              )}
            </Grid>
          </Grid>
        )}
      </>
      {/* CPI Section Ends */}

      <Divider>
        <Typography gutterBottom variant="h5" align="center">
          Currencies Exchange Rates
        </Typography>
      </Divider>

      <ForexRates />

      <Box
        sx={{
          margin: "10px",
        }}
      />
      <Divider>
        <Typography gutterBottom variant="h5" align="center">
          Centeral Bank Interest Rate
        </Typography>
      </Divider>

      <InterestRates />

      {/* <Grid container>
        <Grid item xs={12}>
          <Box sx={{ height: "500px" }}>
            <Card>
              <CardContent>
                <Counties />
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid> */}

      {/* <Box sx={{ margin: "60px" }} /> */}
    </Box>
  );
}
